<template>
  <Icon
    icon-name="icon__audio_arrow--40.svg"
    :style="{ 'transform': rotation }"
  />
</template>

<script>
  import Icon from '../icons/icon';

  export default {
    components: { Icon },
    props: {
      isPrevious: { type: Boolean, required: false, default: true }
    },
    computed: {
      rotation() {
        return this.isPrevious ? 'rotate(180deg)' : 'none';
      }
    }

  };
</script>
